/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Rate request
 */
export interface RateRequest {
  /**
   * Main account or subaccount ID. Main account is used if not set
   */
  accountId?: number;
  pairName: string;
  /**
   * Client request
   */
  clientRequest: number;
  /**
   * Is client request in base currency or not
   */
  clientRequestInBaseCurrency: boolean;
}
